import { render, staticRenderFns } from "./ClassSearchPopComp.vue?vue&type=template&id=0b226ab2&scoped=true"
import script from "./ClassSearchPopComp.vue?vue&type=script&lang=js"
export * from "./ClassSearchPopComp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b226ab2",
  null
  
)

export default component.exports